export default __webpack_public_path__ + "static/media/galerie6.c3389bce.jpg";